rdefine("app/formular/Formular",['backbone',
    'app/formular/components/FormularBuilder',
    'app/formular/components/Tabs',
    'app/formular/models/BuilderModel',
    'text!formular/formular.html',
    'app/formular/models/FormularModel',
    'app/components/SelectOption'],function(Backbone,FormularBuilder,Tabs,BuilderModel,template,FormularModel,SelectOption) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'formular-builder-wrap',
        bindings:{
            '.custom_email_show':{
                classes:{
                    hidden:{
                        processor:function(a){ return !a;},
                        data:'model.notify_custom'
                    }
                }
            },
            "#formular_notify_admin":{
                checked:'model.notify_admin'
            },
            "#formular_accepting":{
                checked:'model.accepting'
            },
            "#formular_notify_email":{
                checked:'model.notify_custom'
            },
            "input[name=base_customemail]":{
                value:{
                    events: 'keyup change',
                    data:'model.custom_email'
                }
            },
            ".action-button":{
                text:{
                    data:'model.id',
                    processor:function(id) {
                        return id?LANGUAGE['basic.apply']:LANGUAGE['basic.apply'];
                    }
                }
            },
            ".cancel-button":{
                attr:{
                    href:{
                        data:'opts.backurl'
                    }
                }
            }
        },
        events:{
            "click .action-button":"doAction"
        },
        tabs:null,
        handlers:{
            customselect:{
                get: function ($el, value) {
                    if ($el.val() !== value) {
                        console.log("cset",$el.find("option[value="+value+"]")[0]);
                        $el.find("option[selected]").removeAttr("selected");
                        $el.find("option[value="+value+"]").attr("selected","selected");
                        $el.val(value);
                    }
                },
                set: function ($el) {
                    return $el.val();
                }
            }
        },
        initialize:function(options) {
            this.$el.html(Template7.compile(template)());
            var tabs=[];
            this.opts=new Backbone.Ribs.Model(options);
            this.model=new FormularModel(options.model || {});
            _.each(options.languages,_.bind(function(language){
                var LocalModel=new BuilderModel({
                    name:'',
                    description:'',
                    finish_message:'',
                    elements:[]
                });

                if(this.model.has(language.shortname)) {
                    LocalModel.set(this.model.get(language.shortname));
                }else{
                    this.model.set(language.shortname,LocalModel.attributes).trigger("change");
                }

                LocalModel.on("change",_.bind(function(){
                    this.model.set(language.shortname,LocalModel.attributes).trigger("change");
                },this));

                tabs.push({
                    title:language.name,
                    module:FormularBuilder,
                    options:{
                        lang:language.shortname,
                        model:LocalModel
                    }
                })
            },this));

            var $tab=new Tabs({
                tabs:tabs
            });

            this.$el.find(".tabsplace").append($tab.el);
            this.model.on("change",_.bind(this.updateValidate,this));
            this.$el.removeClass("loading");
        },
        updateValidate:function() {

        },
        doAction:function() {
            this.$el.addClass("loading");
            var opts=JSON.parse(JSON.stringify(this.model.attributes));
            opts._token=this.opts.get("csrf");
            opts._method="POST";
            if(this.model.get("id",false)) {
                opts._method="PUT";
            }
            $.post(this.opts.get("storeurl"),opts,_.bind(function(response) {
                if(response.success) {
                    window.location=this.opts.get("backurl");
                    return;
                }
                this.$el.removeClass("loading");
                alert("Error");
            },this));
            return false;
        }
    });
});

